import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './SellAllSharesDailyLimitDisclosure.scss';

import { getAllFundsByTicker } from '../../../redux/modules/funds/AllFunds/allFunds.selectors';
import { getUserFundsByAgreementID } from '../../../redux/modules/funds/UserFunds/userFunds.selectors';
import { SELL_ALL_SHARES_DAILY_LIMIT_MODAL } from '../../../redux/modules/modals/modals.module';
import { updateSellFund } from '../../../redux/modules/sellTransaction/sellTransaction.module';
import Button from '../../Shared/Button/Button';
import words from '../../../utils/words';
import { UNIT } from 'src/settings/settings';

const SellAllSharesDailyLimitDisclosure = ({
  isSalesforceRep,
  customerWebViewEnabled,
  closeModal,
  fund: { agreementID },
  updateSellFund,
}) => (
  <div className="e2e-sell-all-shares-daily-limit-container">
    <div className="sell-all-shares-daily-limit-disclosure-heading">
      Unable to Close {words.Fund}
    </div>

    <div className="sell-all-shares-daily-limit-disclosure-disclosure">
      The total withdrawal amount required to close this {words.fund} exceeds
      your daily{' '}
      {!(!customerWebViewEnabled && isSalesforceRep) && <span>online </span>}
      transaction limit.
      {!customerWebViewEnabled && isSalesforceRep ? (
        <span>
          {' '}
          Correct the trade amounts or process through the record keeper.
        </span>
      ) : (
        <span>
          {' '}
          To close this {words.fund},{' '}
          <a
            href="https://www.troweprice.com/personal-investing/help/contact/index.html"
            rel="noreferrer"
            target="_blank"
          >
            contact us
          </a>
          .
        </span>
      )}
    </div>

    <div className="sell-all-shares-daily-limit-disclosure-button-container">
      <Button
        buttonType="primary"
        className="btn-trp-primary e2e-sell-all-shares-daily-limit-confirm-button sell-all-shares-daily-limit-disclosure-ok-button"
        id={`sell-all-shares-daily-limit-modal-ok-btn-${agreementID}`}
        onClick={() => {
          updateSellFund({
            agreementID,
            closeout: false,
            grossAmount: 0,
            grossUnit: UNIT.DOLLARS,
          });
          closeModal(SELL_ALL_SHARES_DAILY_LIMIT_MODAL);
        }}
        styleName="sell-all-shares-daily-limit-disclosure-ok-button"
      >
        OK
      </Button>
    </div>
  </div>
);

const mapStateToProps = (state) => ({
  allFundsByTicker: getAllFundsByTicker(state),
  userFundsByAgreementID: getUserFundsByAgreementID(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateSellFund,
    },
    dispatch
  );

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SellAllSharesDailyLimitDisclosure
);
